export const CLEAR_TOASTS_STATE = 'CLEAR_TOASTS_STATE';
export const ADD_TOAST = 'ADD_TOAST';
export const CLOSE_TOAST = 'CLOSE_TOAST';
export const CLOSE_EXPIRED_TOASTS = 'CLOSE_EXPIRED_TOASTS';
export function clearToastsState() {
    return {
        type: CLEAR_TOASTS_STATE
    };
}
export function addToast(toast) {
    return {
        type: ADD_TOAST,
        payload: toast
    };
}
function closeToast(key) {
    return {
        type: CLOSE_TOAST,
        payload: key
    };
}
function closeExpiredToasts() {
    return {
        type: CLOSE_EXPIRED_TOASTS
    };
}
export function thunkCloseToast(key) {
    return function (dispatch) {
        dispatch(closeToast(key));
        // Closing a toast may expose an older, auto-hide toast that didn't have a chance to display fully and is expired,
        // so close any expired ones now:
        dispatch(closeExpiredToasts());
    };
}
